import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
body {
      background-image: url('images/9.png');
     background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    
       }
    
    @media only screen and (max-width: 1350px) {
    body {
      background-image: url('images/6.png');
      background-attachment: fixed;
      background-position: top;
      background-size: 100%;
      background-repeat: repeat;
    }

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
